import { render, staticRenderFns } from "./VisaoGeralPage.vue?vue&type=template&id=373aa566&scoped=true"
import script from "./VisaoGeralPage.vue?vue&type=script&lang=js"
export * from "./VisaoGeralPage.vue?vue&type=script&lang=js"
import style0 from "./VisaoGeralPage.vue?vue&type=style&index=0&id=373aa566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373aa566",
  null
  
)

export default component.exports